import axios from 'axios';
import { getAccessToken, refreshToken } from './keycloakService';
import localStorageService from 'app/services/localStorageService';
import { getEnv } from 'envConfig';


const env = getEnv();

const axiosInstance = axios.create({
  baseURL: env.ENDPOINT || '',
  timeout: 30000, // 30 seconds timeout
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor: attach access token and add request logging
axiosInstance.interceptors.request.use(
  async (config) => {
    // Try multiple ways to get the access token
    let token = null;
    
    try {
      // First try the keycloak service
      token = await getAccessToken();
      console.log('token', token);
    } catch (error) {
      console.warn('Failed to get token from keycloak service:', error);
    }
    
    // Fallback to localStorage with different possible keys
    if (!token) {
      token = await localStorageService.getItem('access_token')
             
    }
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      
      // Log token for debugging (only in development)
      // if (isDevelopment() && isDebugMode()) {
      //   console.log('🔑 Token attached:', token.substring(0, 20) + '...');
      // }
    } else {
      console.warn('⚠️ No access token found');
    }
    
    // Log request for debugging (only in development and debug mode)
    // if (isDevelopment() && isDebugMode()) {
    //   console.log(`🚀 API Request: ${config.method?.toUpperCase()} ${config.url}`, {
    //     params: config.params,
    //     data: config.data,
    //     headers: {
    //       ...config.headers,
    //       Authorization: config.headers.Authorization ? 'Bearer [HIDDEN]' : 'None'
    //     }
    //   });
    // }
    
    return config;
  },
  (error) => {
    console.error('❌ Request Error:', error);
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // 🔥 Catch both 401 and network redirect errors
    const status = error.response?.status;

    if ((!status && error.message === "Network Error") || status === 401 || status === 302) {
      if (!originalRequest._retry) {
        originalRequest._retry = true;
        try {
          const newAccessToken = await refreshToken();
          axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`;
          originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
          return axiosInstance(originalRequest);
        } catch (refreshError) {
          console.error("❌ Refresh failed:", refreshError);
        }
      }
    }

    return Promise.reject(error);
  }
);




export default axiosInstance; 